/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SendFamilyInviteEmailPathParameters } from 'api/actions/send-family-invite-email/send-family-invite-email-path-parameters';
import { SendFamilyInviteEmailResponse } from 'api/actions/send-family-invite-email/send-family-invite-email-response';

type SendFamilyInviteEmailQueryParameters = Record<string, any>;

/**
 * The path of the SendFamilyInviteEmail action.
 */
export const sendFamilyInviteEmailActionPath = new SweetPath<keyof SendFamilyInviteEmailPathParameters>(
  '/user/family/members/{userId}/send-invite/{lang}',
  { path: '{param}' }
);

/**
 * Creates a contextualized SendFamilyInviteEmail actions.
 */
export default function createSendFamilyInviteEmailAction(axios: AxiosInstance) {
  return function sendFamilyInviteEmailAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: SendFamilyInviteEmailPathParameters;
    query?: SendFamilyInviteEmailQueryParameters;
  }) {
    const path = sendFamilyInviteEmailActionPath.insert(parameters);

    return axios.post<SendFamilyInviteEmailResponse, SendFamilyInviteEmailResponse>(path, { params: query, headers });
  };
}
